import { atom } from 'jotai'

export const addressHistoryLoaderState = atom<boolean>(false)
export const isAddressHistoryLoadedState = atom<boolean>(false)
// Flag to indicate if customer's country doesn't match current country
// When true, address history should not be loaded and new addresses should not be saved
export const isForeignCountryState = atom<boolean>(false)
